import { Directive, input, OnChanges, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';

import { RectComponent } from './skeleton-rect.component';

@Directive({
	selector: '[skeleton]',
	standalone: false,
})
export class SkeletonDirective implements OnChanges {
	readonly isLoading = input(false, { alias: 'skeleton' });
	readonly skeletonRepeat = input(5);
	readonly skeletonWidth = input<string>('rand');
	readonly skeletonHeight = input<string>('30px');
	readonly skeletonClassName = input<string>('mt2');

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainerRef: ViewContainerRef
	) {}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.isLoading) {
			this.viewContainerRef.clear();

			if (changes.isLoading.currentValue) {
				Array.from({ length: this.skeletonRepeat() }).forEach(() => {
					const ref = this.viewContainerRef.createComponent(RectComponent);

					const skeletonWidth = this.skeletonWidth();
					Object.assign(ref.instance, {
						width: skeletonWidth === 'rand' ? `${this.randomNumberFromInterval(30, 90)}%` : skeletonWidth,
						height: this.skeletonHeight(),
						className: this.skeletonClassName(),
					});
				});
			} else {
				this.viewContainerRef.createEmbeddedView(this.templateRef);
			}
		}
	}

	private randomNumberFromInterval(min: number, max: number) {
		return Math.floor(Math.random() * (max - min + 1) + min);
	}
}
